import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../../components/feature/BottomNav';

export default function CustomerInsightPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'insight' | 'strategy' | 'report'>('insight');
  const [selectedCustomer, setSelectedCustomer] = useState<number>(1);
  const [selectedTemplate, setSelectedTemplate] = useState('balanced');
  const [isGenerating, setIsGenerating] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [activeFilter, setActiveFilter] = useState('all');
  const [displayCount, setDisplayCount] = useState(10);
  const [isAiSearchMode, setIsAiSearchMode] = useState(false);
  const [aiSearchQuery, setAiSearchQuery] = useState('');
  const [isAiSearching, setIsAiSearching] = useState(false);
  const [aiFilteredIds, setAiFilteredIds] = useState<number[] | null>(null);

  // 扩展客户列表，增加更多洞察维度
  const allCustomers = [
    {
      id: 1,
      name: '张明',
      avatar: 'https://public.readdy.ai/ai/img_res/0b1e043549480b3037503c5f318a3861.jpg',
      tag: '高净值',
      riskLevel: '平衡型',
      totalAssets: 3280000,
      stocks: 1850000,
      funds: 980000,
      cash: 450000,
      labels: ['ETF偏好者', '打新活跃户', '长期持有'],
      phone: '138****5678',
      // 基础人口统计学维度
      age: 45,
      gender: '男',
      occupation: '民营企业主',
      maritalStatus: '已婚',
      childrenAge: '18岁',
      annualIncome: 1200000,
      debtRatio: 15,
      lifeCycleStage: '财富保值期',
      // 行为与交易维度
      holdingPeriod: '中长线',
      tradingFrequency: '月均3-5次',
      preferredChannel: 'APP自助+微信沟通',
      fundFlowPattern: '季度末有大额转入',
      preferredProducts: ['ETF', '蓝筹股', '公募基金'],
      // 风险与认知维度
      lossTolerancePercent: 15,
      investmentMaturity: '成熟',
      emotionalNeed: '专业咨询',
      reverseInvestmentAwareness: true,
      // 财富目标与场景维度
      primaryGoals: ['子女教育', '退休养老'],
      shortTermGoals: ['企业现金流管理'],
      insuranceGap: '重疾险配置不足',
      taxPlanningNeed: true,
      // 社交与价值主张维度
      socialCircle: '民营企业家圈',
      investmentValues: ['价值投资', '蓝筹偏好'],
      infoSources: ['财新', '雪球'],
      esgInterest: false,
      // 服务记录
      lastContactDate: '2024-01-18',
      contactFrequency: '每周1次',
      satisfactionScore: 4.8
    },
    {
      id: 2,
      name: '李华',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20portrait%20headshot%20wearing%20casual%20suit%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust2&orientation=squarish',
      tag: '活跃客户',
      riskLevel: '进取型',
      totalAssets: 1560000,
      stocks: 1120000,
      funds: 280000,
      cash: 160000,
      labels: ['科技股偏好', '短线交易', '高频操作'],
      phone: '139****1234',
      age: 32,
      gender: '男',
      occupation: '互联网高管',
      maritalStatus: '已婚',
      childrenAge: '3岁',
      annualIncome: 800000,
      debtRatio: 35,
      lifeCycleStage: '财富积累期',
      holdingPeriod: '短线',
      tradingFrequency: '日均2-3次',
      preferredChannel: 'APP自助',
      fundFlowPattern: '每月定期转入',
      preferredProducts: ['科技股', '创业板', '场内ETF'],
      lossTolerancePercent: 25,
      investmentMaturity: '较成熟',
      emotionalNeed: '确定性建议',
      reverseInvestmentAwareness: true,
      primaryGoals: ['财富增值', '子女教育储备'],
      shortTermGoals: ['购置学区房'],
      insuranceGap: '寿险配置不足',
      taxPlanningNeed: false,
      socialCircle: '科创企业家圈',
      investmentValues: ['硬科技赛道', '成长股'],
      infoSources: ['雪球', '同花顺'],
      esgInterest: true,
      lastContactDate: '2024-01-19',
      contactFrequency: '每周2次',
      satisfactionScore: 4.5
    },
    {
      id: 3,
      name: '王芳',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businesswoman%20portrait%20headshot%20wearing%20blazer%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust3&orientation=squarish',
      tag: '潜力客户',
      riskLevel: '保守型',
      totalAssets: 680000,
      stocks: 180000,
      funds: 420000,
      cash: 80000,
      labels: ['基金定投', '稳健投资', '新手客户'],
      phone: '136****9876',
      age: 38,
      gender: '女',
      occupation: '体制内公务员',
      maritalStatus: '已婚',
      childrenAge: '10岁',
      annualIncome: 350000,
      debtRatio: 20,
      lifeCycleStage: '财富积累期',
      holdingPeriod: '长线',
      tradingFrequency: '月均1-2次',
      preferredChannel: '微信沟通为主',
      fundFlowPattern: '每月工资日转入',
      preferredProducts: ['债券基金', '货币基金', '指数基金'],
      lossTolerancePercent: 8,
      investmentMaturity: '初级',
      emotionalNeed: '陪伴与安心',
      reverseInvestmentAwareness: false,
      primaryGoals: ['子女教育', '家庭保障'],
      shortTermGoals: ['子女兴趣班费用'],
      insuranceGap: '教育金险未配置',
      taxPlanningNeed: false,
      socialCircle: '体制内同事圈',
      investmentValues: ['稳健保本', '低风险'],
      infoSources: ['银行理财经理', '朋友推荐'],
      esgInterest: false,
      lastContactDate: '2024-01-17',
      contactFrequency: '每两周1次',
      satisfactionScore: 4.6
    },
    {
      id: 4,
      name: '陈伟',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20middle%20aged%20businessman%20portrait%20headshot%20wearing%20formal%20suit%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust4&orientation=squarish',
      tag: '高净值',
      riskLevel: '平衡型',
      totalAssets: 5680000,
      stocks: 2850000,
      funds: 1980000,
      cash: 850000,
      labels: ['蓝筹股偏好', '长期持有', 'VIP客户'],
      phone: '137****2345',
      age: 52,
      gender: '男',
      occupation: '上市公司高管',
      maritalStatus: '已婚',
      childrenAge: '22岁',
      annualIncome: 2000000,
      debtRatio: 10,
      lifeCycleStage: '财富传承期',
      holdingPeriod: '长线',
      tradingFrequency: '月均1-2次',
      preferredChannel: '电话+面谈',
      fundFlowPattern: '年终奖大额转入',
      preferredProducts: ['蓝筹股', '私募基金', '信托'],
      lossTolerancePercent: 12,
      investmentMaturity: '成熟',
      emotionalNeed: '专业咨询',
      reverseInvestmentAwareness: true,
      primaryGoals: ['财富传承', '退休养老'],
      shortTermGoals: ['子女婚房准备'],
      insuranceGap: '传承规划未完善',
      taxPlanningNeed: true,
      socialCircle: '退休高管圈',
      investmentValues: ['价值投资', '分红股'],
      infoSources: ['财新', '券商研报'],
      esgInterest: true,
      lastContactDate: '2024-01-16',
      contactFrequency: '每周1次',
      satisfactionScore: 4.9
    },
    {
      id: 5,
      name: '刘洋',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20young%20businessman%20portrait%20headshot%20wearing%20business%20casual%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust5&orientation=squarish',
      tag: '活跃客户',
      riskLevel: '进取型',
      totalAssets: 980000,
      stocks: 720000,
      funds: 180000,
      cash: 80000,
      labels: ['新能源偏好', '波段操作', '研究型'],
      phone: '135****6789',
      age: 28,
      gender: '男',
      occupation: '自由职业',
      maritalStatus: '未婚',
      childrenAge: '-',
      annualIncome: 500000,
      debtRatio: 5,
      lifeCycleStage: '财富积累期',
      holdingPeriod: '中短线',
      tradingFrequency: '日均1-2次',
      preferredChannel: 'APP自助',
      fundFlowPattern: '不定期转入',
      preferredProducts: ['新能源股', '创业板', '可转债'],
      lossTolerancePercent: 30,
      investmentMaturity: '较成熟',
      emotionalNeed: '确定性建议',
      reverseInvestmentAwareness: true,
      primaryGoals: ['财富快速增值'],
      shortTermGoals: ['购车'],
      insuranceGap: '基础保障不足',
      taxPlanningNeed: false,
      socialCircle: '投资交流群',
      investmentValues: ['趋势投资', '热点追踪'],
      infoSources: ['雪球', '抖音财经'],
      esgInterest: true,
      lastContactDate: '2024-01-19',
      contactFrequency: '每周3次',
      satisfactionScore: 4.3
    },
    {
      id: 6,
      name: '赵静',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businesswoman%20portrait%20headshot%20wearing%20elegant%20blazer%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust6&orientation=squarish',
      tag: '潜力客户',
      riskLevel: '保守型',
      totalAssets: 420000,
      stocks: 50000,
      funds: 200000,
      cash: 100000,
      labels: ['货币基金', '低风险', '新开户'],
      phone: '158****3456',
      age: 35,
      gender: '女',
      occupation: '医生',
      maritalStatus: '已婚',
      childrenAge: '5岁',
      annualIncome: 400000,
      debtRatio: 25,
      lifeCycleStage: '财富积累期',
      holdingPeriod: '长线',
      tradingFrequency: '月均1次',
      preferredChannel: '微信沟通',
      fundFlowPattern: '每月定期转入',
      preferredProducts: ['货币基金', '银行理财', '国债'],
      lossTolerancePercent: 5,
      investmentMaturity: '初级',
      emotionalNeed: '陪伴与安心',
      reverseInvestmentAwareness: false,
      primaryGoals: ['子女教育', '家庭保障'],
      shortTermGoals: ['装修款储备'],
      insuranceGap: '医疗险已配置，教育金未配置',
      taxPlanningNeed: false,
      socialCircle: '医疗行业圈',
      investmentValues: ['稳健保本'],
      infoSources: ['银行APP', '朋友推荐'],
      esgInterest: false,
      lastContactDate: '2024-01-15',
      contactFrequency: '每月2次',
      satisfactionScore: 4.4
    },
    {
      id: 7,
      name: '孙磊',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20portrait%20headshot%20wearing%20dark%20suit%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust7&orientation=squarish',
      tag: '高净值',
      riskLevel: '进取型',
      totalAssets: 8920000,
      stocks: 5680000,
      funds: 2240000,
      cash: 1000000,
      labels: ['私募偏好', '高频交易', 'SVIP客户'],
      phone: '186****7890',
      age: 48,
      gender: '男',
      occupation: '投资公司创始人',
      maritalStatus: '已婚',
      childrenAge: '16岁',
      annualIncome: 5000000,
      debtRatio: 8,
      lifeCycleStage: '财富保值期',
      holdingPeriod: '灵活',
      tradingFrequency: '日均5次以上',
      preferredChannel: '专属客户经理',
      fundFlowPattern: '大额不定期',
      preferredProducts: ['私募基金', '股指期货', '场外期权'],
      lossTolerancePercent: 35,
      investmentMaturity: '专业级',
      emotionalNeed: '专业咨询',
      reverseInvestmentAwareness: true,
      primaryGoals: ['财富传承', '资产配置优化'],
      shortTermGoals: ['海外资产配置'],
      insuranceGap: '家族信托未设立',
      taxPlanningNeed: true,
      socialCircle: '私募圈',
      investmentValues: ['绝对收益', '对冲策略'],
      infoSources: ['Bloomberg', '券商VIP研报'],
      esgInterest: true,
      lastContactDate: '2024-01-19',
      contactFrequency: '每日',
      satisfactionScore: 4.9
    },
    {
      id: 8,
      name: '周婷',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20young%20businesswoman%20portrait%20headshot%20wearing%20modern%20blazer%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust8&orientation=squarish',
      tag: '活跃客户',
      riskLevel: '平衡型',
      totalAssets: 1280000,
      stocks: 580000,
      funds: 520000,
      cash: 180000,
      labels: ['消费股偏好', '价值投资', '定投用户'],
      phone: '159****4567',
      age: 33,
      gender: '女',
      occupation: '外企中层',
      maritalStatus: '已婚',
      childrenAge: '1岁',
      annualIncome: 600000,
      debtRatio: 30,
      lifeCycleStage: '财富积累期',
      holdingPeriod: '中长线',
      tradingFrequency: '周均2-3次',
      preferredChannel: 'APP+微信',
      fundFlowPattern: '每月定投',
      preferredProducts: ['消费股', '指数基金', '混合基金'],
      lossTolerancePercent: 15,
      investmentMaturity: '较成熟',
      emotionalNeed: '确定性建议',
      reverseInvestmentAwareness: false,
      primaryGoals: ['子女教育', '财富增值'],
      shortTermGoals: ['换房首付'],
      insuranceGap: '重疾险额度不足',
      taxPlanningNeed: false,
      socialCircle: '高净值女性圈',
      investmentValues: ['消费升级', '品质生活'],
      infoSources: ['小红书', '理财公众号'],
      esgInterest: true,
      lastContactDate: '2024-01-18',
      contactFrequency: '每周1次',
      satisfactionScore: 4.7
    }
  ];

  // 保留原有的其他客户数据（简化版本）
  const additionalCustomers = [
    {
      id: 4,
      name: '陈伟',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20middle%20aged%20businessman%20portrait%20headshot%20wearing%20formal%20suit%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust4&orientation=squarish',
      tag: '高净值',
      riskLevel: '平衡型',
      totalAssets: 5680000,
      stocks: 2850000,
      funds: 1980000,
      cash: 850000,
      labels: ['蓝筹股偏好', '长期持有', 'VIP客户'],
      phone: '137****2345',
      age: 52,
      gender: '男',
      occupation: '上市公司高管',
      maritalStatus: '已婚',
      childrenAge: '22岁',
      annualIncome: 2000000,
      debtRatio: 10,
      lifeCycleStage: '财富传承期',
      holdingPeriod: '长线',
      tradingFrequency: '月均1-2次',
      preferredChannel: '电话+面谈',
      fundFlowPattern: '年终奖大额转入',
      preferredProducts: ['蓝筹股', '私募基金', '信托'],
      lossTolerancePercent: 12,
      investmentMaturity: '成熟',
      emotionalNeed: '专业咨询',
      reverseInvestmentAwareness: true,
      primaryGoals: ['财富传承', '退休养老'],
      shortTermGoals: ['子女婚房准备'],
      insuranceGap: '传承规划未完善',
      taxPlanningNeed: true,
      socialCircle: '退休高管圈',
      investmentValues: ['价值投资', '分红股'],
      infoSources: ['财新', '券商研报'],
      esgInterest: true,
      lastContactDate: '2024-01-16',
      contactFrequency: '每周1次',
      satisfactionScore: 4.9
    },
    {
      id: 5,
      name: '刘洋',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20young%20businessman%20portrait%20headshot%20wearing%20business%20casual%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust5&orientation=squarish',
      tag: '活跃客户',
      riskLevel: '进取型',
      totalAssets: 980000,
      stocks: 720000,
      funds: 180000,
      cash: 80000,
      labels: ['新能源偏好', '波段操作', '研究型'],
      phone: '135****6789',
      age: 28,
      gender: '男',
      occupation: '自由职业',
      maritalStatus: '未婚',
      childrenAge: '-',
      annualIncome: 500000,
      debtRatio: 5,
      lifeCycleStage: '财富积累期',
      holdingPeriod: '中短线',
      tradingFrequency: '日均1-2次',
      preferredChannel: 'APP自助',
      fundFlowPattern: '不定期转入',
      preferredProducts: ['新能源股', '创业板', '可转债'],
      lossTolerancePercent: 30,
      investmentMaturity: '较成熟',
      emotionalNeed: '确定性建议',
      reverseInvestmentAwareness: true,
      primaryGoals: ['财富快速增值'],
      shortTermGoals: ['购车'],
      insuranceGap: '基础保障不足',
      taxPlanningNeed: false,
      socialCircle: '投资交流群',
      investmentValues: ['趋势投资', '热点追踪'],
      infoSources: ['雪球', '抖音财经'],
      esgInterest: true,
      lastContactDate: '2024-01-19',
      contactFrequency: '每周3次',
      satisfactionScore: 4.3
    },
    {
      id: 6,
      name: '赵静',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businesswoman%20portrait%20headshot%20wearing%20elegant%20blazer%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust6&orientation=squarish',
      tag: '潜力客户',
      riskLevel: '保守型',
      totalAssets: 420000,
      stocks: 50000,
      funds: 200000,
      cash: 100000,
      labels: ['货币基金', '低风险', '新开户'],
      phone: '158****3456',
      age: 35,
      gender: '女',
      occupation: '医生',
      maritalStatus: '已婚',
      childrenAge: '5岁',
      annualIncome: 400000,
      debtRatio: 25,
      lifeCycleStage: '财富积累期',
      holdingPeriod: '长线',
      tradingFrequency: '月均1次',
      preferredChannel: '微信沟通',
      fundFlowPattern: '每月定期转入',
      preferredProducts: ['货币基金', '银行理财', '国债'],
      lossTolerancePercent: 5,
      investmentMaturity: '初级',
      emotionalNeed: '陪伴与安心',
      reverseInvestmentAwareness: false,
      primaryGoals: ['子女教育', '家庭保障'],
      shortTermGoals: ['装修款储备'],
      insuranceGap: '医疗险已配置，教育金未配置',
      taxPlanningNeed: false,
      socialCircle: '医疗行业圈',
      investmentValues: ['稳健保本'],
      infoSources: ['银行APP', '朋友推荐'],
      esgInterest: false,
      lastContactDate: '2024-01-15',
      contactFrequency: '每月2次',
      satisfactionScore: 4.4
    },
    {
      id: 7,
      name: '孙磊',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20portrait%20headshot%20wearing%20dark%20suit%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust7&orientation=squarish',
      tag: '高净值',
      riskLevel: '进取型',
      totalAssets: 8920000,
      stocks: 5680000,
      funds: 2240000,
      cash: 1000000,
      labels: ['私募偏好', '高频交易', 'SVIP客户'],
      phone: '186****7890',
      age: 48,
      gender: '男',
      occupation: '投资公司创始人',
      maritalStatus: '已婚',
      childrenAge: '16岁',
      annualIncome: 5000000,
      debtRatio: 8,
      lifeCycleStage: '财富保值期',
      holdingPeriod: '灵活',
      tradingFrequency: '日均5次以上',
      preferredChannel: '专属客户经理',
      fundFlowPattern: '大额不定期',
      preferredProducts: ['私募基金', '股指期货', '场外期权'],
      lossTolerancePercent: 35,
      investmentMaturity: '专业级',
      emotionalNeed: '专业咨询',
      reverseInvestmentAwareness: true,
      primaryGoals: ['财富传承', '资产配置优化'],
      shortTermGoals: ['海外资产配置'],
      insuranceGap: '家族信托未设立',
      taxPlanningNeed: true,
      socialCircle: '私募圈',
      investmentValues: ['绝对收益', '对冲策略'],
      infoSources: ['Bloomberg', '券商VIP研报'],
      esgInterest: true,
      lastContactDate: '2024-01-19',
      contactFrequency: '每日',
      satisfactionScore: 4.9
    },
    {
      id: 8,
      name: '周婷',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20young%20businesswoman%20portrait%20headshot%20wearing%20modern%20blazer%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=cust8&orientation=squarish',
      tag: '活跃客户',
      riskLevel: '平衡型',
      totalAssets: 1280000,
      stocks: 580000,
      funds: 520000,
      cash: 180000,
      labels: ['消费股偏好', '价值投资', '定投用户'],
      phone: '159****4567',
      age: 33,
      gender: '女',
      occupation: '外企中层',
      maritalStatus: '已婚',
      childrenAge: '1岁',
      annualIncome: 600000,
      debtRatio: 30,
      lifeCycleStage: '财富积累期',
      holdingPeriod: '中长线',
      tradingFrequency: '周均2-3次',
      preferredChannel: 'APP+微信',
      fundFlowPattern: '每月定投',
      preferredProducts: ['消费股', '指数基金', '混合基金'],
      lossTolerancePercent: 15,
      investmentMaturity: '较成熟',
      emotionalNeed: '确定性建议',
      reverseInvestmentAwareness: false,
      primaryGoals: ['子女教育', '财富增值'],
      shortTermGoals: ['换房首付'],
      insuranceGap: '重疾险额度不足',
      taxPlanningNeed: false,
      socialCircle: '高净值女性圈',
      investmentValues: ['消费升级', '品质生活'],
      infoSources: ['小红书', '理财公众号'],
      esgInterest: true,
      lastContactDate: '2024-01-18',
      contactFrequency: '每周1次',
      satisfactionScore: 4.7
    }
  ];

  const fullCustomerList = [...allCustomers.slice(0, 3), ...additionalCustomers];

  const customers = fullCustomerList.slice(0, 3);

  const reports = [
    { id: 1, customer: '张明', date: '2024-01-15', type: '账户复盘', status: 'sent', summary: '本周账户收益+2.3%，跑赢沪深300指数1.2个百分点' },
    { id: 2, customer: '李华', date: '2024-01-14', type: '账户复盘', status: 'draft', summary: '本周账户收益-0.8%，建议调整持仓结构' },
    { id: 3, customer: '王芳', date: '2024-01-13', type: '账户复盘', status: 'sent', summary: '本周账户收益+1.5%，基金定投计划执行良好' }
  ];

  const selectedCustomerData = fullCustomerList.find(c => c.id === selectedCustomer);

  const showMessage = (msg: string) => {
    setToastMessage(msg);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  const handleGenerateStrategy = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      navigate('/strategy-detail');
    }, 1500);
  };

  const handleGenerateReport = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      navigate('/report-detail');
    }, 1500);
  };

  const tabs = [
    { key: 'insight', label: '客户洞察', icon: 'ri-user-search' },
    { key: 'strategy', label: 'AI策略', icon: 'ri-magic' },
    { key: 'report', label: '报告助手', icon: 'ri-file-chart' }
  ];

  const filterOptions = [
    { key: 'all', label: '全部' },
    { key: 'high', label: '高净值' },
    { key: 'active', label: '活跃客户' },
    { key: 'potential', label: '潜力客户' }
  ];

  const aiSearchPresets = [
    '资产超过500万的高净值客户',
    '风险偏好进取型的活跃客户',
    '适合推荐基金定投的客户',
    '近期可能有理财需求的新客户',
    '持有科技股的长期投资者',
    '资产在100-300万的平衡型客户'
  ];

  // AI搜索逻辑
  const handleAiSearch = () => {
    if (!aiSearchQuery.trim()) return;
    
    setIsAiSearching(true);
    
    setTimeout(() => {
      const query = aiSearchQuery.toLowerCase();
      let filtered = [...fullCustomerList];
      
      // 解析资产要求
      const assetMatch = query.match(/(\d+)万/);
      if (assetMatch) {
        const targetAsset = parseFloat(assetMatch[1]) * 10000;
        if (query.includes('超过') || query.includes('以上') || query.includes('大于')) {
          filtered = filtered.filter(c => c.totalAssets >= targetAsset);
        } else if (query.includes('低于') || query.includes('以下') || query.includes('小于')) {
          filtered = filtered.filter(c => c.totalAssets <= targetAsset);
        } else if (query.includes('-') || query.includes('到') || query.includes('之间')) {
          const rangeMatch = query.match(/(\d+).*?(\d+)万/);
          if (rangeMatch) {
            const min = parseFloat(rangeMatch[1]) * 10000;
            const max = parseFloat(rangeMatch[2]) * 10000;
            filtered = filtered.filter(c => c.totalAssets >= min && c.totalAssets <= max);
          }
        }
      }
      
      // 解析客户标签
      if (query.includes('高净值')) {
        filtered = filtered.filter(c => c.tag === '高净值');
      }
      if (query.includes('活跃')) {
        filtered = filtered.filter(c => c.tag === '活跃客户');
      }
      if (query.includes('潜力') || query.includes('新客')) {
        filtered = filtered.filter(c => c.tag === '潜力客户');
      }
      
      // 解析风险偏好
      if (query.includes('进取') || query.includes('激进') || query.includes('高风险')) {
        filtered = filtered.filter(c => c.riskLevel === '进取型');
      }
      if (query.includes('平衡') || query.includes('稳健')) {
        filtered = filtered.filter(c => c.riskLevel === '平衡型');
      }
      if (query.includes('保守') || query.includes('低风险')) {
        filtered = filtered.filter(c => c.riskLevel === '保守型');
      }
      
      // 解析投资偏好标签
      if (query.includes('定投') || query.includes('基金定投')) {
        filtered = filtered.filter(c => c.labels.some(l => l.includes('定投') || l.includes('基金')));
      }
      if (query.includes('科技') || query.includes('科技股')) {
        filtered = filtered.filter(c => c.labels.some(l => l.includes('科技') || l.includes('半导体') || l.includes('新能源')));
      }
      if (query.includes('长期') || query.includes('长线')) {
        filtered = filtered.filter(c => c.labels.some(l => l.includes('长期') || l.includes('长线') || l.includes('价值')));
      }
      if (query.includes('短线') || query.includes('高频')) {
        filtered = filtered.filter(c => c.labels.some(l => l.includes('短线') || l.includes('高频') || l.includes('波段')));
      }
      if (query.includes('ETF')) {
        filtered = filtered.filter(c => c.labels.some(l => l.includes('ETF')));
      }
      if (query.includes('VIP') || query.includes('SVIP')) {
        filtered = filtered.filter(c => c.labels.some(l => l.includes('VIP')));
      }
      
      // 解析理财需求
      if (query.includes('理财需求') || query.includes('新开户') || query.includes('新手')) {
        filtered = filtered.filter(c => c.labels.some(l => l.includes('新') || l.includes('观望')));
      }
      
      setAiFilteredIds(filtered.map(c => c.id));
      setIsAiSearching(false);
      setDisplayCount(10);
    }, 1200);
  };

  const clearAiSearch = () => {
    setAiSearchQuery('');
    setAiFilteredIds(null);
  };

  const filteredCustomers = fullCustomerList.filter(customer => {
    // AI搜索模式
    if (isAiSearchMode && aiFilteredIds !== null) {
      return aiFilteredIds.includes(customer.id);
    }
    
    // 普通搜索模式
    const matchesSearch = searchKeyword === '' || 
      customer.name.includes(searchKeyword) || 
      customer.phone.includes(searchKeyword) ||
      customer.labels.some(label => label.includes(searchKeyword));
    
    const matchesFilter = activeFilter === 'all' || 
      (activeFilter === 'high' && customer.tag === '高净值') ||
      (activeFilter === 'active' && customer.tag === '活跃客户') ||
      (activeFilter === 'potential' && customer.tag === '潜力客户');
    
    return matchesSearch && matchesFilter;
  });

  const displayedCustomers = filteredCustomers.slice(0, displayCount);
  const hasMore = displayCount < filteredCustomers.length;

  const handleSelectCustomerFromModal = (customerId: number) => {
    setSelectedCustomer(customerId);
    setShowCustomerModal(false);
    showMessage('已切换客户');
  };

  const handleLoadMore = () => {
    setDisplayCount(prev => prev + 10);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 pb-20">
      {/* Header */}
      <div className="fixed top-0 left-0 right-0 z-10 bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-5 pt-8 pb-4">
        <div className="flex items-center gap-3 mb-2">
          <h1 className="text-lg font-bold flex-1">客户洞察</h1>
          <button 
            onClick={() => setShowCustomerModal(true)}
            className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full backdrop-blur-sm"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>
        <div className="text-xs text-blue-100">智能分析 | 精准画像 | 128位客户</div>
      </div>

      {/* Spacer for fixed header */}
      <div className="h-[88px]"></div>

      {/* Customer Quick Selector - 最顶部 */}
      <div className="px-5 py-3 bg-white/95 backdrop-blur-sm border-b border-gray-100">
        <div className="flex items-center gap-3 overflow-x-auto pb-1 scrollbar-hide">
          {customers.map((customer) => (
            <button
              key={customer.id}
              onClick={() => setSelectedCustomer(customer.id)}
              className={`flex items-center gap-2 px-3 py-2 rounded-full whitespace-nowrap transition-all ${
                selectedCustomer === customer.id
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-500'
              }`}
            >
              <img src={customer.avatar} alt={customer.name} className="w-6 h-6 rounded-full object-cover" />
              <span className="text-xs font-medium">{customer.name}</span>
            </button>
          ))}
          <button 
            onClick={() => setShowCustomerModal(true)}
            className="flex items-center gap-1 px-3 py-2 rounded-full bg-gray-100 text-gray-500 whitespace-nowrap"
          >
            <i className="ri-add-line"></i>
            <span className="text-xs">更多</span>
          </button>
        </div>
      </div>

      {/* Tab Switcher - 客户选择器下方 */}
      <div className="px-5 py-3 bg-white/80 backdrop-blur-sm border-b border-gray-100">
        <div className="flex gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key as typeof activeTab)}
              className={`flex-1 py-2 px-3 rounded-full text-sm font-medium transition-all flex items-center justify-center gap-1 ${
                activeTab === tab.key
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-700'
              }`}
            >
              <i className={`${tab.icon}-line text-base`}></i>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Customer Search Modal */}
      {showCustomerModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end">
          <div className="bg-white w-full rounded-t-3xl max-h-[85vh] flex flex-col animate-slide-up">
            {/* Modal Header */}
            <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
              <h3 className="text-lg font-bold text-gray-800">选择客户</h3>
              <button 
                onClick={() => {
                  setShowCustomerModal(false);
                  setSearchKeyword('');
                  setActiveFilter('all');
                  setDisplayCount(10);
                  setIsAiSearchMode(false);
                  setAiSearchQuery('');
                  setAiFilteredIds(null);
                }}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100"
              >
                <i className="ri-close-line text-gray-600"></i>
              </button>
            </div>

            {/* Search Mode Toggle */}
            <div className="px-5 py-3 border-b border-gray-100">
              <div className="flex bg-gray-100 rounded-full p-1">
                <button
                  onClick={() => {
                    setIsAiSearchMode(false);
                    setAiFilteredIds(null);
                    setAiSearchQuery('');
                  }}
                  className={`flex-1 py-2 rounded-full text-sm font-medium transition-all flex items-center justify-center gap-1 ${
                    !isAiSearchMode ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-600'
                  }`}
                >
                  <i className="ri-search-line"></i>
                  <span>普通搜索</span>
                </button>
                <button
                  onClick={() => {
                    setIsAiSearchMode(true);
                    setSearchKeyword('');
                    setActiveFilter('all');
                  }}
                  className={`flex-1 py-2 rounded-full text-sm font-medium transition-all flex items-center justify-center gap-1 ${
                    isAiSearchMode ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-sm' : 'text-gray-600'
                  }`}
                >
                  <i className="ri-magic-line"></i>
                  <span>AI智能搜索</span>
                </button>
              </div>
            </div>

            {/* AI Search Section */}
            {isAiSearchMode ? (
              <div className="px-5 py-3 border-b border-gray-100">
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-4 border border-purple-100">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg">
                      <i className="ri-magic-line text-white text-xs"></i>
                    </div>
                    <span className="text-sm font-bold text-gray-800">用自然语言描述您要找的客户</span>
                  </div>
                  <div className="flex gap-2 mb-3">
                    <input
                      type="text"
                      value={aiSearchQuery}
                      onChange={(e) => setAiSearchQuery(e.target.value)}
                      onKeyDown={(e) => e.key === 'Enter' && handleAiSearch()}
                      placeholder="例如：资产超过500万的高净值客户"
                      className="flex-1 px-4 py-2.5 bg-white rounded-xl text-sm border border-purple-200 focus:outline-none focus:ring-2 focus:ring-purple-400"
                    />
                    <button
                      onClick={handleAiSearch}
                      disabled={isAiSearching || !aiSearchQuery.trim()}
                      className="px-4 py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl text-sm font-medium active:scale-95 transition-transform disabled:opacity-50"
                    >
                      {isAiSearching ? (
                        <i className="ri-loader-4-line animate-spin"></i>
                      ) : (
                        <i className="ri-search-line"></i>
                      )}
                    </button>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {aiSearchPresets.map((preset, idx) => (
                      <button
                        key={idx}
                        onClick={() => {
                          setAiSearchQuery(preset);
                        }}
                        className="px-3 py-1.5 bg-white/80 text-purple-700 text-xs rounded-full border border-purple-200 hover:bg-white transition-colors"
                      >
                        {preset}
                      </button>
                    ))}
                  </div>
                </div>
                
                {/* AI Search Result Info */}
                {aiFilteredIds !== null && (
                  <div className="mt-3 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <i className="ri-sparkling-line text-purple-600"></i>
                      <span className="text-sm text-gray-600">
                        AI为您找到 <span className="font-bold text-purple-600">{aiFilteredIds.length}</span> 位匹配客户
                      </span>
                    </div>
                    <button
                      onClick={clearAiSearch}
                      className="text-sm text-gray-500 hover:text-gray-700"
                    >
                      <i className="ri-close-circle-line mr-1"></i>
                      清除结果
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                {/* Normal Search Bar */}
                <div className="px-5 py-3 border-b border-gray-100">
                  <div className="relative">
                    <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
                    <input
                      type="text"
                      value={searchKeyword}
                      onChange={(e) => {
                        setSearchKeyword(e.target.value);
                        setDisplayCount(10);
                      }}
                      placeholder="搜索客户姓名、手机号、标签..."
                      className="w-full pl-10 pr-4 py-2.5 bg-gray-100 rounded-xl text-sm border-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {searchKeyword && (
                      <button 
                        onClick={() => setSearchKeyword('')}
                        className="absolute right-3 top-1/2 -translate-y-1/2"
                      >
                        <i className="ri-close-circle-fill text-gray-400"></i>
                      </button>
                    )}
                  </div>
                </div>

                {/* Filter Tabs */}
                <div className="px-5 py-3 border-b border-gray-100">
                  <div className="flex gap-2 overflow-x-auto scrollbar-hide">
                    {filterOptions.map((filter) => (
                      <button
                        key={filter.key}
                        onClick={() => {
                          setActiveFilter(filter.key);
                          setDisplayCount(10);
                        }}
                        className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-all ${
                          activeFilter === filter.key
                            ? 'bg-blue-600 text-white'
                            : 'bg-gray-100 text-gray-600'
                        }`}
                      >
                        {filter.label}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}

            {/* Customer Stats */}
            <div className="px-5 py-2 bg-gray-50 text-xs text-gray-500">
              共 {filteredCustomers.length} 位客户
            </div>

            {/* Customer List */}
            <div className="flex-1 overflow-y-auto px-5 py-3">
              {displayedCustomers.length > 0 ? (
                <div className="space-y-3">
                  {displayedCustomers.map((customer) => (
                    <div
                      key={customer.id}
                      onClick={() => handleSelectCustomerFromModal(customer.id)}
                      className={`p-4 rounded-xl border-2 cursor-pointer transition-all ${
                        selectedCustomer === customer.id
                          ? 'bg-blue-50 border-blue-500'
                          : 'bg-white border-gray-100 hover:border-blue-200'
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <img 
                          src={customer.avatar} 
                          alt={customer.name} 
                          className="w-12 h-12 rounded-xl object-cover"
                        />
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <span className="font-bold text-gray-800">{customer.name}</span>
                            <span className={`px-2 py-0.5 text-xs rounded-full ${
                              customer.tag === '高净值' ? 'bg-purple-100 text-purple-600' :
                              customer.tag === '活跃客户' ? 'bg-green-100 text-green-600' :
                              'bg-orange-100 text-orange-600'
                            }`}>
                              {customer.tag}
                            </span>
                          </div>
                          <div className="flex items-center gap-3 text-xs text-gray-500">
                            <span>{customer.phone}</span>
                            <span>|</span>
                            <span>{customer.riskLevel}</span>
                            <span>|</span>
                            <span>¥{(customer.totalAssets / 10000).toFixed(0)}万</span>
                          </div>
                          <div className="flex gap-1 mt-2 flex-wrap">
                            {customer.labels.slice(0, 3).map((label, idx) => (
                              <span key={idx} className="px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded">
                                {label}
                              </span>
                            ))}
                          </div>
                        </div>
                        {selectedCustomer === customer.id && (
                          <i className="ri-checkbox-circle-fill text-xl text-blue-600"></i>
                        )}
                      </div>
                    </div>
                  ))}

                  {/* Load More Button */}
                  {hasMore && (
                    <button
                      onClick={handleLoadMore}
                      className="w-full py-3 bg-gray-100 text-gray-600 rounded-xl text-sm font-medium active:bg-gray-200 transition-colors"
                    >
                      <i className="ri-arrow-down-line mr-1"></i>
                      加载更多 ({filteredCustomers.length - displayCount} 位)
                    </button>
                  )}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-12 text-gray-400">
                  <i className="ri-user-search-line text-5xl mb-3"></i>
                  <p className="text-sm">未找到匹配的客户</p>
                  <button 
                    onClick={() => {
                      setSearchKeyword('');
                      setActiveFilter('all');
                    }}
                    className="mt-3 text-blue-600 text-sm"
                  >
                    清除筛选条件
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Tab Content */}
      <div className="px-5 pt-4 space-y-4">
        {/* 客户洞察 Tab */}
        {activeTab === 'insight' && selectedCustomerData && (
          <>
            {/* Customer Profile Card */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <div className="flex items-center gap-4 mb-4">
                <img src={selectedCustomerData.avatar} alt={selectedCustomerData.name} className="w-16 h-16 rounded-xl object-cover" />
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-lg font-bold text-gray-800">{selectedCustomerData.name}</span>
                    <span className="px-2 py-0.5 bg-purple-100 text-purple-600 text-xs rounded-full">{selectedCustomerData.tag}</span>
                  </div>
                  <div className="text-sm text-gray-500">风险等级：{selectedCustomerData.riskLevel}</div>
                </div>
              </div>
              <div className="flex gap-2 flex-wrap">
                {selectedCustomerData.labels.map((label, idx) => (
                  <span key={idx} className="px-3 py-1 bg-blue-50 text-blue-600 text-xs rounded-full">{label}</span>
                ))}
              </div>
            </div>

            {/* 基础人口统计学维度 */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-100 rounded-lg">
                  <i className="ri-user-3-line text-blue-600"></i>
                </div>
                <h3 className="text-base font-bold text-gray-800">基础画像</h3>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-500 mb-1">年龄/性别</div>
                  <div className="text-sm font-bold text-gray-800">{selectedCustomerData.age}岁 / {selectedCustomerData.gender}</div>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-500 mb-1">职业</div>
                  <div className="text-sm font-bold text-gray-800">{selectedCustomerData.occupation}</div>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-500 mb-1">婚姻/子女</div>
                  <div className="text-sm font-bold text-gray-800">{selectedCustomerData.maritalStatus} / {selectedCustomerData.childrenAge}</div>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-500 mb-1">生命周期</div>
                  <div className="text-sm font-bold text-gray-800">{selectedCustomerData.lifeCycleStage}</div>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-500 mb-1">年收入</div>
                  <div className="text-sm font-bold text-gray-800">¥{(selectedCustomerData.annualIncome / 10000).toFixed(0)}万</div>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-500 mb-1">负债率</div>
                  <div className="text-sm font-bold text-gray-800">{selectedCustomerData.debtRatio}%</div>
                </div>
              </div>
            </div>

            {/* 行为与交易维度 */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-lg">
                  <i className="ri-line-chart-line text-green-600"></i>
                </div>
                <h3 className="text-base font-bold text-gray-800">交易行为</h3>
              </div>
              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">持仓周期</span>
                  <span className="text-sm font-bold text-gray-800">{selectedCustomerData.holdingPeriod}</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">交易频率</span>
                  <span className="text-sm font-bold text-gray-800">{selectedCustomerData.tradingFrequency}</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">偏好渠道</span>
                  <span className="text-sm font-bold text-gray-800">{selectedCustomerData.preferredChannel}</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">资金规律</span>
                  <span className="text-sm font-bold text-gray-800">{selectedCustomerData.fundFlowPattern}</span>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="text-sm text-gray-600 mb-2">偏好产品</div>
                  <div className="flex flex-wrap gap-2">
                    {selectedCustomerData.preferredProducts.map((product, idx) => (
                      <span key={idx} className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">{product}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* 风险与认知维度 */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-lg">
                  <i className="ri-shield-check-line text-orange-600"></i>
                </div>
                <h3 className="text-base font-bold text-gray-800">风险认知</h3>
              </div>
              <div className="space-y-3">
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="flex justify-between text-sm mb-2">
                    <span className="text-gray-600">风险承受力</span>
                    <span className="font-bold text-orange-600">可承受{selectedCustomerData.lossTolerancePercent}%亏损</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-green-500 via-yellow-500 to-red-500 rounded-full"
                      style={{ width: `${Math.min(selectedCustomerData.lossTolerancePercent * 2.5, 100)}%` }}
                    ></div>
                  </div>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">投资成熟度</span>
                  <span className={`px-2 py-1 text-xs rounded-full ${
                    selectedCustomerData.investmentMaturity === '专业级' ? 'bg-purple-100 text-purple-600' :
                    selectedCustomerData.investmentMaturity === '成熟' ? 'bg-blue-100 text-blue-600' :
                    selectedCustomerData.investmentMaturity === '较成熟' ? 'bg-green-100 text-green-600' :
                    'bg-gray-100 text-gray-600'
                  }`}>{selectedCustomerData.investmentMaturity}</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">情绪价值需求</span>
                  <span className="text-sm font-bold text-gray-800">{selectedCustomerData.emotionalNeed}</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">逆向投资意识</span>
                  <span className={`px-2 py-1 text-xs rounded-full ${selectedCustomerData.reverseInvestmentAwareness ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-600'}`}>
                    {selectedCustomerData.reverseInvestmentAwareness ? '具备' : '不具备'}
                  </span>
                </div>
              </div>
            </div>

            {/* 财富目标与场景维度 */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-purple-100 rounded-lg">
                  <i className="ri-flag-line text-purple-600"></i>
                </div>
                <h3 className="text-base font-bold text-gray-800">财富目标</h3>
              </div>
              <div className="space-y-3">
                <div className="p-3 bg-purple-50 rounded-xl">
                  <div className="text-sm text-purple-700 font-medium mb-2">核心目标</div>
                  <div className="flex flex-wrap gap-2">
                    {selectedCustomerData.primaryGoals.map((goal, idx) => (
                      <span key={idx} className="px-3 py-1 bg-purple-100 text-purple-700 text-xs rounded-full">{goal}</span>
                    ))}
                  </div>
                </div>
                <div className="p-3 bg-blue-50 rounded-xl">
                  <div className="text-sm text-blue-700 font-medium mb-2">短期目标</div>
                  <div className="flex flex-wrap gap-2">
                    {selectedCustomerData.shortTermGoals.map((goal, idx) => (
                      <span key={idx} className="px-3 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">{goal}</span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center justify-between p-3 bg-orange-50 rounded-xl">
                  <span className="text-sm text-orange-700">保障缺口</span>
                  <span className="text-sm font-medium text-orange-700">{selectedCustomerData.insuranceGap}</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">税务筹划需求</span>
                  <span className={`px-2 py-1 text-xs rounded-full ${selectedCustomerData.taxPlanningNeed ? 'bg-red-100 text-red-600' : 'bg-gray-100 text-gray-600'}`}>
                    {selectedCustomerData.taxPlanningNeed ? '有需求' : '暂无'}
                  </span>
                </div>
              </div>
            </div>

            {/* 社交与价值主张维度 */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-pink-100 rounded-lg">
                  <i className="ri-team-line text-pink-600"></i>
                </div>
                <h3 className="text-base font-bold text-gray-800">社交圈层</h3>
              </div>
              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">所属圈层</span>
                  <span className="px-3 py-1 bg-pink-100 text-pink-700 text-xs rounded-full">{selectedCustomerData.socialCircle}</span>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="text-sm text-gray-600 mb-2">投资价值观</div>
                  <div className="flex flex-wrap gap-2">
                    {selectedCustomerData.investmentValues.map((value, idx) => (
                      <span key={idx} className="px-2 py-1 bg-indigo-100 text-indigo-700 text-xs rounded-full">{value}</span>
                    ))}
                  </div>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl">
                  <div className="text-sm text-gray-600 mb-2">信息来源</div>
                  <div className="flex flex-wrap gap-2">
                    {selectedCustomerData.infoSources.map((source, idx) => (
                      <span key={idx} className="px-2 py-1 bg-cyan-100 text-cyan-700 text-xs rounded-full">{source}</span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <span className="text-sm text-gray-600">ESG投资兴趣</span>
                  <span className={`px-2 py-1 text-xs rounded-full ${selectedCustomerData.esgInterest ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-600'}`}>
                    {selectedCustomerData.esgInterest ? '关注' : '不关注'}
                  </span>
                </div>
              </div>
            </div>

            {/* 资产全景视图 */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-cyan-100 rounded-lg">
                  <i className="ri-pie-chart-line text-cyan-600"></i>
                </div>
                <h3 className="text-base font-bold text-gray-800">资产全景</h3>
              </div>
              <div className="mb-4">
                <div className="text-center mb-4">
                  <div className="text-xs text-gray-500 mb-1">总资产</div>
                  <div className="text-2xl font-bold text-gray-800">¥{(selectedCustomerData.totalAssets / 10000).toFixed(1)}万</div>
                </div>
                <div className="h-3 bg-gray-100 rounded-full overflow-hidden flex">
                  <div className="bg-gradient-to-r from-red-500 to-orange-500" style={{ width: `${(selectedCustomerData.stocks / selectedCustomerData.totalAssets) * 100}%` }}></div>
                  <div className="bg-gradient-to-r from-blue-500 to-cyan-500" style={{ width: `${(selectedCustomerData.funds / selectedCustomerData.totalAssets) * 100}%` }}></div>
                  <div className="bg-gradient-to-r from-green-500 to-teal-500" style={{ width: `${(selectedCustomerData.cash / selectedCustomerData.totalAssets) * 100}%` }}></div>
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-gradient-to-r from-red-500 to-orange-500 rounded-full"></div>
                    <span className="text-sm text-gray-600">股票持仓</span>
                  </div>
                  <span className="text-sm font-bold text-gray-800">¥{(selectedCustomerData.stocks / 10000).toFixed(1)}万</span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full"></div>
                    <span className="text-sm text-gray-600">基金持仓</span>
                  </div>
                  <span className="text-sm font-bold text-gray-800">¥{(selectedCustomerData.funds / 10000).toFixed(1)}万</span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-gradient-to-r from-green-500 to-teal-500 rounded-full"></div>
                    <span className="text-sm text-gray-600">现金管理</span>
                  </div>
                  <span className="text-sm font-bold text-gray-800">¥{(selectedCustomerData.cash / 10000).toFixed(1)}万</span>
                </div>
              </div>
            </div>

            {/* 服务记录 */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-lg">
                  <i className="ri-customer-service-2-line text-teal-600"></i>
                </div>
                <h3 className="text-base font-bold text-gray-800">服务记录</h3>
              </div>
              <div className="grid grid-cols-3 gap-3">
                <div className="text-center p-3 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-500 mb-1">最近联系</div>
                  <div className="text-sm font-bold text-gray-800">{selectedCustomerData.lastContactDate}</div>
                </div>
                <div className="text-center p-3 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-500 mb-1">联系频率</div>
                  <div className="text-sm font-bold text-gray-800">{selectedCustomerData.contactFrequency}</div>
                </div>
                <div className="text-center p-3 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-500 mb-1">满意度</div>
                  <div className="text-sm font-bold text-yellow-600">
                    <i className="ri-star-fill mr-1"></i>{selectedCustomerData.satisfactionScore}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* AI策略 Tab */}
        {activeTab === 'strategy' && selectedCustomerData && (
          <>
            {/* Selected Customer Info */}
            <div className="bg-white rounded-2xl shadow-lg p-4">
              <div className="flex items-center gap-3">
                <img src={selectedCustomerData.avatar} alt={selectedCustomerData.name} className="w-12 h-12 rounded-xl object-cover" />
                <div className="flex-1">
                  <div className="font-bold text-gray-800">{selectedCustomerData.name}</div>
                  <div className="text-sm text-gray-500">{selectedCustomerData.riskLevel} | 总资产 ¥{(selectedCustomerData.totalAssets / 10000).toFixed(1)}万</div>
                </div>
                <span className="px-2 py-1 bg-purple-100 text-purple-600 text-xs rounded-full">{selectedCustomerData.tag}</span>
              </div>
            </div>

            {/* Action Buttons - 移到上方 */}
            <div className="flex gap-3">
              <button
                onClick={handleGenerateStrategy}
                disabled={isGenerating}
                className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 rounded-xl font-bold shadow-lg active:scale-95 transition-transform disabled:opacity-50 flex items-center justify-center"
              >
                {isGenerating ? (
                  <span><i className="ri-loader-4-line mr-2 animate-spin"></i>生成中...</span>
                ) : (
                  <span><i className="ri-magic-line mr-2"></i>生成策略</span>
                )}
              </button>
              <button
                onClick={() => navigate('/strategy-detail')}
                className="flex-1 bg-white border-2 border-purple-200 text-purple-600 py-3 rounded-xl font-bold shadow-sm active:scale-95 transition-transform flex items-center justify-center"
              >
                <i className="ri-history-line mr-2"></i>历史策略
              </button>
            </div>

            {/* Strategy Template */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <h3 className="text-base font-bold text-gray-800 mb-4">策略模板</h3>
              <div className="space-y-3">
                {[
                  { key: 'balanced', icon: 'ri-pie-chart-line', title: '均衡配置策略', desc: '股债平衡，稳健增长' },
                  { key: 'growth', icon: 'ri-line-chart-line', title: '成长进取策略', desc: '股票为主，追求高收益' },
                  { key: 'conservative', icon: 'ri-shield-check-line', title: '稳健保守策略', desc: '固收为主，控制风险' }
                ].map((item) => (
                  <div
                    key={item.key}
                    onClick={() => setSelectedTemplate(item.key)}
                    className={`flex items-center gap-3 p-4 rounded-xl border-2 cursor-pointer transition-all ${
                      selectedTemplate === item.key ? 'bg-purple-50 border-purple-500' : 'bg-gray-50 border-transparent'
                    }`}
                  >
                    <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${selectedTemplate === item.key ? 'bg-purple-500' : 'bg-gray-400'}`}>
                      <i className={`${item.icon} text-white text-lg`}></i>
                    </div>
                    <div className="flex-1">
                      <div className="font-bold text-gray-800 text-sm">{item.title}</div>
                      <div className="text-xs text-gray-500">{item.desc}</div>
                    </div>
                    {selectedTemplate === item.key && <i className="ri-checkbox-circle-fill text-xl text-purple-500"></i>}
                  </div>
                ))}
              </div>
            </div>

            {/* Market Environment */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <h3 className="text-base font-bold text-gray-800 mb-4">市场环境分析</h3>
              <div className="space-y-2">
                <div className="flex items-center justify-between p-3 bg-green-50 rounded-xl">
                  <div className="flex items-center gap-2">
                    <i className="ri-arrow-up-line text-green-600"></i>
                    <span className="text-sm text-gray-700">A股市场</span>
                  </div>
                  <span className="text-sm font-bold text-green-600">震荡向上</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-blue-50 rounded-xl">
                  <div className="flex items-center gap-2">
                    <i className="ri-arrow-right-line text-blue-600"></i>
                    <span className="text-sm text-gray-700">债券市场</span>
                  </div>
                  <span className="text-sm font-bold text-blue-600">平稳运行</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-orange-50 rounded-xl">
                  <div className="flex items-center gap-2">
                    <i className="ri-arrow-down-line text-orange-600"></i>
                    <span className="text-sm text-gray-700">流动性</span>
                  </div>
                  <span className="text-sm font-bold text-orange-600">适度收紧</span>
                </div>
              </div>
            </div>

            {/* Expected Returns */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <h3 className="text-base font-bold text-gray-800 mb-4">预期收益测算</h3>
              <div className="grid grid-cols-3 gap-2">
                <div className="text-center p-3 bg-gradient-to-br from-green-50 to-teal-50 rounded-xl">
                  <div className="text-xs text-gray-600 mb-1">乐观</div>
                  <div className="text-lg font-bold text-green-600">+12.5%</div>
                </div>
                <div className="text-center p-3 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl">
                  <div className="text-xs text-gray-600 mb-1">中性</div>
                  <div className="text-lg font-bold text-blue-600">+8.2%</div>
                </div>
                <div className="text-center p-3 bg-gradient-to-br from-orange-50 to-red-50 rounded-xl">
                  <div className="text-xs text-gray-600 mb-1">悲观</div>
                  <div className="text-lg font-bold text-orange-600">+3.8%</div>
                </div>
              </div>
              <div className="mt-3 p-3 bg-gray-50 rounded-xl">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">最大回撤风险</span>
                  <span className="font-bold text-red-600">-8.5%</span>
                </div>
              </div>
            </div>
          </>
        )}

        {/* 报告助手 Tab */}
        {activeTab === 'report' && selectedCustomerData && (
          <>
            {/* Quick Generate Card */}
            <div className="bg-gradient-to-r from-indigo-600 to-blue-600 rounded-2xl shadow-lg p-5 text-white">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-file-chart-line text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="font-bold mb-1">快速生成报告</h3>
                  <p className="text-xs text-indigo-100">自动分析账户表现，生成专业复盘</p>
                </div>
              </div>
              
              <div className="space-y-3 mb-4">
                <div className="bg-white/10 rounded-xl p-3 backdrop-blur-sm">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm">当前客户</span>
                  </div>
                  <div className="text-sm font-medium">{selectedCustomerData.name} ({selectedCustomerData.riskLevel} | ¥{(selectedCustomerData.totalAssets / 10000).toFixed(1)}万)</div>
                </div>
                
                <div className="bg-white/10 rounded-xl p-3 backdrop-blur-sm">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm">报告周期</span>
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                  <div className="text-sm font-medium">本周 (2024.01.15 - 2024.01.19)</div>
                </div>
              </div>

              <button
                onClick={handleGenerateReport}
                disabled={isGenerating}
                className="w-full py-3 bg-white text-indigo-600 rounded-xl font-bold shadow-lg active:scale-95 transition-transform disabled:opacity-50"
              >
                {isGenerating ? (
                  <span><i className="ri-loader-4-line mr-2 animate-spin"></i>生成中...</span>
                ) : (
                  <span><i className="ri-magic-line mr-2"></i>智能生成报告</span>
                )}
              </button>
            </div>

            {/* Report History */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-base font-bold text-gray-800">历史报告</h3>
                <button className="text-sm text-indigo-600 font-medium">
                  查看全部<i className="ri-arrow-right-s-line ml-1"></i>
                </button>
              </div>

              <div className="space-y-3">
                {reports.map((report) => (
                  <div key={report.id} className="p-4 bg-gray-50 rounded-xl">
                    <div className="flex items-start gap-3 mb-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-indigo-100 rounded-xl">
                        <i className="ri-file-text-line text-indigo-600 text-lg"></i>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <h4 className="font-bold text-gray-800 text-sm">{report.customer}</h4>
                          <span className={`px-2 py-0.5 text-xs rounded-full ${
                            report.status === 'sent' ? 'bg-green-100 text-green-600' : 'bg-orange-100 text-orange-600'
                          }`}>
                            {report.status === 'sent' ? '已发送' : '草稿'}
                          </span>
                        </div>
                        <div className="text-xs text-gray-500 mb-1">{report.type} · {report.date}</div>
                        <p className="text-xs text-gray-600">{report.summary}</p>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button 
                        onClick={() => navigate('/report-detail')}
                        className="flex-1 py-2 bg-indigo-600 text-white rounded-lg text-xs font-medium active:scale-95 transition-transform"
                      >
                        <i className="ri-eye-line mr-1"></i>查看
                      </button>
                      <button className="px-3 py-2 bg-white border border-gray-200 text-gray-700 rounded-lg text-xs font-medium active:scale-95 transition-transform">
                        <i className="ri-send-plane-line"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Report Settings */}
            <div className="bg-white rounded-2xl shadow-lg p-5">
              <h3 className="text-base font-bold text-gray-800 mb-4">报告模板设置</h3>
              <div className="space-y-2">
                {[
                  { label: '包含持仓明细', checked: true },
                  { label: '包含收益分析', checked: true },
                  { label: '包含优化建议', checked: true },
                  { label: '自动推送客户', checked: false }
                ].map((item, idx) => (
                  <label key={idx} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl cursor-pointer">
                    <span className="text-sm text-gray-700">{item.label}</span>
                    <div className="relative">
                      <input type="checkbox" defaultChecked={item.checked} className="sr-only peer" />
                      <div className="w-10 h-5 bg-gray-300 rounded-full peer-checked:bg-indigo-500 transition-colors"></div>
                      <div className="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full transition-transform peer-checked:translate-x-5"></div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </>
        )}
      </div>

      {/* Toast */}
      {showToast && (
        <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-black/80 text-white px-6 py-3 rounded-xl z-50 animate-pulse">
          <i className="ri-check-line mr-2"></i>{toastMessage}
        </div>
      )}

      <BottomNav />
    </div>
  );
}
